import React from 'react';
import Input from 'components/Input';

export default function RenderedInput({
  input,
  label,
  type,
  id,
  placeholder,
  meta,
  disabled = false
}) {
  const { touched, error, warning, valid } = meta;

  return (
    <React.Fragment>
      <Input
        {...input}
        type={type}
        id={id}
        placeholder={placeholder}
        valid={!touched || (touched && valid)}
        disabled={disabled}
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </React.Fragment>
  );
}
